import { formatText } from 'core/i18n';

export const DEFAULT_STEPS = 'defaultSteps';
export const AUTHORIZED_STEPS = 'authorizedSteps';
export const CLIENT_STEPS = 'clientSteps';
export const CONFIG_CARD_STEPS = 'configCardSteps';
export const ROBO_STEPS = 'roboSteps';

export const DEPOSIT_STEPS = 'depositSteps';

export const CREDIT_CARD_STEPS = 'creditCardSteps';
export const GBI_STEPS = 'gbiSteps';

export const PERSONAL_DATA_VIEW = 'personalDataStep';
export const PROFESSIONAL_DATA_VIEW = 'professionalDataStep';
export const DEPOSIT_VIEW = 'deposit-config';

export const IDENTIFICATION_VIEW = 'identificationStep';
export const SIGNING_CONTRACT_VIEW = 'signingContractStep';
export const DOCUMENTATION_VIEW = 'documentationStep';
export const CONFIG_CARD_VIEW = 'configCard';
export const CREDIT_CARD_VIEW = 'creditCard';
export const SUITABILITY_TEST_VIEW = 'suitabilityTest';
export const GBI_INVESTMENT_VIEW = 'gbiInvestmentView';
export const INVESTMENT_PLAN_VIEW = 'investmentPlanView';
export const OTP_TRANSFER_VIEW = 'otpTransferView';
export const SIGNATURE_KEY_VIEW = 'signature-key';

export const PERSONAL_DATA_TITLE_STEP = formatText('stepsTitles-personalData');
export const PROFESSIONAL_DATA_TITLE_STEP = formatText('stepsTitles-professionalData');
export const IDENTIFICATION_TITLE_STEP = formatText('stepsTitles-identityVerification');
export const SIGNING_TITLE_STEP = formatText('stepsTitles-signingContract');
export const DOCUMENTATION_TITLE_STEP = formatText('stepsTitles-documentation');

export const LOGALTY_IMPLEMENTATION = 'logalty';
export const DOCUSIGN_IMPLEMENTATION = 'docusign';

export const OPENSTATE_RESPONSE_TYPES = {
    EMPTY: 'EMPTY',
    IN_PROGRESS: 'IN PROGRESS',
    FAIL: 'FAIL',
    SUCCESS: 'SUCCESS',
};
